<div class="rounded-2xl bg-white p-10 shadow-sm border border-slate-100">
  <h2 class="text-xl font-semibold text-slate-900">Sign in to continue</h2>
  <p class="mt-2 text-slate-500 mb-6">
    Please authenticate to access this survey.
  </p>
  <button
    class="w-full rounded-xl bg-slate-900 py-3 text-white hover:bg-slate-800 transition-colors"
  >
    Login
  </button>
</div>
